// extracted by mini-css-extract-plugin
module.exports = {"main-icon":"main-icon__b2Mib","arrow-icon":"arrow-icon__20E7m","item":"item__2Nj7z"};